<template lang='pug'>
  div(v-loading="avatarLoading").pos-r.of-h.rounded-circle.bg-white.border
    div(v-if="imageUrl").pin.pin-center.size-100
      img(:src="avatarUrl" alt="Avatar").w-100.obj-f-c
    div(v-else).pin.pin-xy.d-flex
      font-awesome-icon(:icon="['fal', 'user']" :size="iconSize").text-muted.m-auto
</template>

<script>
export default {
  name: 'Avatar',

  props: {
    imageUrl: { default: '', type: String },
    iconSize: { default: '2x', type: String },
  },

  data() {
    return {
      avatarLoading: false,
      avatarUrl: '',
    };
  },

  watch: {
    imageUrl(val) {
      if (val) this.getAvatar();
    },
  },

  created() {
    if (this.imageUrl) this.getAvatar();
  },

  methods: {
    loadImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', () => resolve(img));
        img.addEventListener('error', reject);
        img.src = url;
      });
    },

    getAvatar() {
      this.avatarLoading = true;

      this.loadImage(this.imageUrl).then((data) => {
        this.avatarLoading = false;
        this.avatarUrl = data.src;
      });
    },
  },
};
</script>
